import { ISingleIdParams } from '../types/actionParams';
import { IMetricActions } from '../types/IMetricActions';
import { Request } from './Request';

export class GetMetricActionsRequest extends Request<ISingleIdParams, IMetricActions> {
  constructor(id: string) {
    super('getMetricActions', { id: id });
  }
}
